import { render } from "./Info.vue?vue&type=template&id=76381d40&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-76381d40"

export default script